<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='ID'
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="频道名"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.notification"
              label="频道通告"
              type="textarea"
              removable
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-select
              label="频道类型"
              v-model="insertData.type"
              :options="typeOptions"
              :onchange="handleChannelTypeChange"
            />
          </div>
          <va-button-group v-show="showChargeOption">
            <va-button :color="this.showBoundCourse ? 'info' : 'gray'" v-on:click="handleBoundCourseChange(true)">绑定课程</va-button>
            <va-button :color="!this.showBoundCourse ? 'info' : 'gray'" v-on:click="handleBoundCourseChange(false)">不绑定课程</va-button>
          </va-button-group>
          <div class="flex md12 sm6 xs12" v-show="showChargeOption && showBoundCourse">
            <va-select
              label="课程类型"
              v-model="insertData.channelCourse.serviceType"
              :options="courseTypeOptions"
              :onchange="handleCourseTypeChange"
            />
          </div>
          <div class="flex md12 sm6 xs12" v-show="showChargeOption && showBoundCourse">
            <va-select
              label="关联课程"
              v-model="insertData.channelCourse.serviceId"
              :options="courseOptions"
            />
          </div>
          <div class="flex md12 sm6 xs12" v-show="showChargeOption && !showBoundCourse">
            <va-input
              v-model="insertData.channelCourse.name"
              label="二级标题"
              removable
            />
          </div>
          <div class="flex md12 sm6 xs12" v-show="showChargeOption">
            <va-select
              label="导师"
                searchable
              v-model="insertData.channelCourse.mentor.nickname"
              :options="mentorOptions"
            />
          </div>
          <div class="flex md12 sm6 xs12" v-show="showChargeOption">
            <va-input
              v-model="insertData.channelCourse.previewUrl"
              label="课程预览地址"
              removable
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>

        <div class='flex md2 offset--md5'>
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>

      </va-card>
    </div>
  </div>
</template>

<script>

import { copyObject, counterStrLength } from '../../utils/common'
import groupApi from '../../api/group'
import mentorApi from '@/api/mentor'
import { COURSE_TYPE, COURSE_TYPES } from '@/utils/constants'
import onlineActionApi from '@/api/onlineAction'
import jobCounselingApi from '@/api/jobCounseling'
import enterpriseToOneApi from '@/api/enterpriseToOne'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        notification: '',
        type: null,
        sortNum: null,
        channelId: null,
        channelCourse: {
          id: null,
          name: '',
          previewUrl: '',
          serviceId: null,
          serviceType: null,
          mentor: {},
          course: {},
        },
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        sortNumErrors: [],
      },
      title: '创建频道',
      showId: false,
      showChargeOption: false,
      showBoundCourse: true,
      submitButtonStatus: true,
      typeOptions: ['普通', '付费'],
      mentorOptions: [],
      courseTypeOptions: COURSE_TYPES.map(x => x.TEXT),
      courseOptions: [],
      mentorMaps: {},
      courseMaps: {},
      serviceTypes: COURSE_TYPE,
    }
  },
  created () {
    const params = this.$route.params
    this.groupId = params.groupId
    this.id = params.id
    if (params.id != null) {
      this.showId = true
      this.title = '编辑频道'
      // 通过id获取详情
      groupApi.getChannelInfo(params.id).then(response => {
        copyObject(response, this.insertData)
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('type')) {
          if (response.type === 1) {
            this.insertData.type = '普通'
          } else {
            this.insertData.type = '付费'
            this.showChargeOption = true
          }
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('channelCourse') && response.channelCourse.hasOwnProperty('serviceType') && response.channelCourse.hasOwnProperty('serviceId')) {
          this.showBoundCourse = true
          response.channelCourse.mentor = this.insertData.channelCourse.mentor
          response.channelCourse.course = this.insertData.channelCourse.course
          COURSE_TYPES.map(x => {
            if (x.CODE === response.channelCourse.serviceType) {
              this.insertData.channelCourse.serviceType = x.TEXT
            }
            this.listCourse(this.insertData.channelCourse.serviceType)
          })
        } else {
          this.showBoundCourse = false
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.channelCourse.hasOwnProperty('mentorUid')) {
          this.insertData.channelCourse.mentor.nickname = response.channelCourse.mentor.nickname + '(' + response.channelCourse.mentorUid + ')'
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    } else {

    }
    this.listMentor()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.sortNumErrors.length
    },
    handleCourseTypeChange () {
      COURSE_TYPES.map(x => {
        if (this.insertData.channelCourse.serviceType === x.TEXT) {
          this.listCourse(x.CODE)
          return true
        }
      })
      return false
    },
    handleChannelTypeChange () {
      this.showChargeOption = this.insertData.type === '付费'
      return true
    },
  },
  methods: {
    listMentor () {
      const params = {
        isActive: this.isActive,
      }
      mentorApi.listMentor(params).then(response => {
        response.mentors.map(x => {
          this.mentorOptions.push(x.nickname + '(' + x.uid + ')')
          this.mentorMaps[x.nickname + '(' + x.uid + ')'] = x.uid
        })
      }).catch(error => alert(error.msg))
    },
    listCourse (serviceType) {
      if (serviceType == null) {
        return
      }
      if (serviceType === this.serviceTypes.ONLINE_ACTION.CODE) {
        this.listOnlineAction({})
      } else if (serviceType === this.serviceTypes.ENTERPRISE_TO_ONE.CODE) {
        this.listEnterpriseToOne({})
      } else if (serviceType === this.serviceTypes.JOB_COUNSELING.CODE) {
        this.listJobCounseling({})
      }
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        groupId: this.groupId,
        name: this.insertData.name,
        notification: this.insertData.notification,
        sortNum: this.insertData.sortNum,
        previewUrl: this.insertData.channelCourse.previewUrl,
        serviceType: null,
        serviceId: null,
        subName: this.insertData.channelCourse.name,
        mentorUid: '',
      }

      // 校验name和notification长度
      if (counterStrLength(data.name) > 30) {
        this.showToast('频道名过长，IM规则最长30字节', {
          duration: 3000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }

      if (counterStrLength(data.notification) > 300) {
        this.showToast('公告过长，IM规则最长300字节', {
          duration: 3000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }

      if (this.insertData.type === '普通') {
        data.type = 1
      } else {
        data.type = 2
        data.mentorUid = this.mentorMaps[this.insertData.channelCourse.mentor.nickname]
        if (this.insertData.channelCourse.serviceType !== null && this.insertData.channelCourse.serviceId !== null && this.showBoundCourse === true) {
          data.serviceType = this.computeServiceType()
          data.serviceId = this.courseMaps[this.insertData.channelCourse.serviceId]
        }
      }
      console.log(data)
      if (this.insertData.id !== null) {
        // 编辑
        data.id = this.insertData.id
        groupApi.updateChannel(data).then(response => {
          if (response.success === true) {
            this.showToast('保存频道成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listChannel' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        groupApi.createChannel(data).then(response => {
          this.showToast('更新频道成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.$router.push({ name: 'listChannel' })
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    listOnlineAction (params) {
      onlineActionApi.listOnlineAction(params).then(response => {
        this.courseOptions = []
        this.courseMaps = {}
        response.onlineActions.forEach(x => {
          this.courseOptions.push(x.name)
          this.courseMaps[x.name] = x.id
          if (x.id === this.insertData.channelCourse.serviceId) {
            this.insertData.channelCourse.serviceId = x.name
          }
        })
      })
    },
    listEnterpriseToOne (params) {
      enterpriseToOneApi.listEnterpriseToOne(params).then(response => {
        this.courseOptions = []
        this.courseMaps = {}
        response.enterpriseToOnes.forEach(x => {
          this.courseOptions.push(x.name)
          this.courseMaps[x.name] = x.id
          if (x.id === this.insertData.channelCourse.serviceId) {
            this.insertData.channelCourse.serviceId = x.name
          }
        })
      })
    },
    listJobCounseling (params) {
      jobCounselingApi.listJobCounseling(params).then(response => {
        this.courseOptions = []
        this.courseMaps = {}
        response.jobCounselings.forEach(x => {
          this.courseOptions.push(x.name)
          this.courseMaps[x.name] = x.id
          if (x.id === this.insertData.channelCourse.serviceId) {
            this.insertData.channelCourse.serviceId = x.name
          }
        })
      })
    },
    computeServiceType () {
      let res = -1
      COURSE_TYPES.map(x => {
        if (x.TEXT === this.insertData.channelCourse.serviceType) {
          res = x.CODE
        }
      })
      return res
    },
    handleBoundCourseChange (type) {
      this.showBoundCourse = type
    },
  },
}

</script>
